// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const patternStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
    description: string;
  };
} = {
  'accept-rate': {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'compact', 'size'],
    description: "A widget which display a user's accept rate",
  },
  'ai-button': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default'],
    description: 'Button to trigger AI actions',
  },
  'ai-chatbot-message': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: [
      'default',
      'avatar-variant',
      'custom-content',
      'loading',
      'loading-phrases',
      'loading-style',
      'show-avatar',
    ],
    description:
      'Left-aligned message from the AI chatbot displayed with its avatar in a conversational AI thread.',
  },
  'ai-modal': {
    path: '',
    tags: ['ai', 'modals'],
    internalOnly: false,
    stories: ['default', 'error-state'],
    description: 'Modal to display AI actions',
  },
  'ai-question-card': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default', 'disabled', 'question'],
    description:
      'Question card shown inline in a conversational AI thread when the AI chatbot asks a question.',
  },
  'ai-text-editor': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default'],
    description:
      'AI text editor with writing assistant actions (proofread, improve, change tone, speech-to-text)',
  },
  'ai-textarea': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: [
      'default',
      'attachments',
      'busy',
      'button-text',
      'disabled',
      'hide-outer-glow',
      'hint',
      'keep-keyboard-open-on-submit',
      'max-lines',
      'single-line',
      'skip-label',
      'toolbar-variants',
      'validation',
      'voice-input',
    ],
    description:
      'AI textarea with a toolbar that includes a send button and optional attachments and voice input buttons.',
  },
  'ai-user-bubble': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default', 'attachments', 'attachments-only'],
    description:
      "Right-aligned blue bubble for the user's messages in a conversational AI thread.",
  },
  'auto-complete': {
    path: '',
    tags: ['controls'],
    internalOnly: false,
    stories: ['default', 'user-mention'],
    description:
      'Provides selectable suggestions triggered by the tagging directive keys',
  },
  'auto-link': {
    path: '',
    tags: ['text & links'],
    internalOnly: false,
    stories: ['default'],
    description: 'Directive to auto-link',
  },
  'best-practises': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default'],
    description: "Banners which inform users what the do's and dont's are",
  },
  'bid-pattern-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      'The bid card pattern display the bid indormation in a single element.',
  },
  'bouncing-dots': {
    path: '',
    tags: ['loading', 'dots', 'typing', 'indicator'],
    internalOnly: true,
    stories: ['default', 'sizes'],
    description:
      'Three staggered bouncing dots — the "native chat" typing cue.',
  },
  'challenge-card': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default', 'compact', 'custom', 'loading'],
    description: 'Redesigned innovation challenge card',
  },
  'challenge-status-tag': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default'],
    description: 'Tags with challenge status',
  },
  'chat-button': {
    path: '',
    tags: ['controls'],
    internalOnly: false,
    stories: ['default', 'icon-only', 'responsive'],
    description: 'Chat button with built in unread count',
  },
  'comment-ui': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default', 'active', 'badges', 'header-icon'],
    description:
      'A comment displays user feedback and discussion thread on the platform.',
  },
  'completed-jobs': {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'size'],
    description:
      'Is used to display the percent of completed jobs that the user have done',
  },
  confetti: {
    path: '',
    tags: [
      'popups / overlays',
      'confetti',
      'celebration',
      'animation',
      'party',
      'success',
    ],
    internalOnly: true,
    stories: ['default'],
    description: 'Full-screen confetti celebration overlay.',
  },
  'directory-item': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'alignment', 'arrow-colors', 'custom-content'],
    description: 'Distinct bulleted lists for a bunch of links',
  },
  earnings: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'compact', 'flip-value', 'size'],
    description: "A widget which display a user's earnings",
  },
  'empty-state': {
    path: '',
    tags: ['other'],
    internalOnly: true,
    stories: ['default'],
    description: 'A basic pattern for consistent empty states.',
  },
  experience: {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: [
      'default',
      'background-color',
      'education',
      'linked-roles',
      'publications',
      'qualifications',
    ],
    description: 'Layout for Freelancer Experience',
  },
  'image-caption': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'color'],
    description: 'Shows information about images',
  },
  'interactive-text': {
    path: '',
    tags: ['text & links'],
    internalOnly: false,
    stories: ['default', 'highlighted-text', 'max-lines'],
    description: 'Interactive text that supports emojis and links',
  },
  linkshim: {
    path: '',
    tags: ['text & links'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Link shim checks the link on click for any malicious content and run them against our internal lists to determine if the url is something we can redirect to.',
  },
  'loading-avatar-row-card': {
    path: '',
    tags: ['loading', 'avatar', 'row', 'skeleton'],
    internalOnly: false,
    stories: ['default'],
    description: 'A skeleton row of an avatar plus loading text',
  },
  'loading-text': {
    path: '',
    tags: ['loading'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A placeholder to be used in place of text being fetched from network',
  },
  'loading-thread-item': {
    path: '',
    tags: ['loading', 'thread', 'messaging'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A placeholder for a thread list item being fetched from network',
  },
  'moonshot-promo-banner': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default'],
    description: 'Promo banner for Freelancer Moonshot Innovation Challenges',
  },
  'newsfeed-system-messages': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default'],
    description:
      'The newsfeed system messages pattern contain the structure needed for the newsfeed items.',
  },
  'project-contest-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      'The project-contest-card pattern display the project/contest information in a single element.',
  },
  'radio-card': {
    path: '',
    tags: ['controls'],
    internalOnly: false,
    stories: [
      'default',
      'borders',
      'custom-content',
      'disable',
      'image-alignment',
      'show-radio',
    ],
    description: 'Radio input with built-in layouting subcomponents',
  },
  'review-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: [
      'default',
      'perspective',
      'reply',
      'services',
      'skills',
      'summary',
    ],
    description: 'Layout for Review card',
  },
  'review-count': {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'size'],
    description:
      'Review count is used to display the amount of reviews the user has received',
  },
  'section-article': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'alignment', 'button', 'colors', 'sizes', 'title'],
    description:
      'A simple grid module for sections of text, images, cards etc.',
  },
  'section-case-study-carousel': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'caption', 'footer', 'header-detail', 'quote'],
    description: 'A carousel displaying case studies on landing pages.',
  },
  'section-companies': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'colors', 'custom-title', 'logos-list'],
    description: 'Used in landing pages to display company logos',
  },
  'section-feature': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: [
      'default',
      'alignment',
      'border-top',
      'dark-background',
      'full-width',
      'image-overflow',
      'overlay',
      'sizes',
    ],
    description: 'A section used for highlighting features on landing pages.',
  },
  'section-gallery': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'dot-indicator', 'image-caption', 'thumbnails'],
    description: '',
  },
  'section-hero': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: [
      'default',
      'alignment',
      'colors',
      'content-width',
      'detail-text',
      'height',
      'image-detail',
      'video-background',
    ],
    description:
      'Also commonly referred to as the Hero Header and Hero Image is a lightweight, flexible component to showcase key content on your page.',
  },
  'service-offering-carousel': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default', 'edit-mode'],
    description:
      'Carousel with custom layout and action options for service offerings and their categories',
  },
  'share-modal': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: true,
    stories: ['default', 'card'],
    description: 'Modal for displaying the video component',
  },
  'showcase-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: [
      'default',
      'aspect-ratio',
      'carousel',
      'clickable',
      'expandable-content',
      'not-image',
      'scale-on-hover',
      'showcase-card-variant',
    ],
    description: 'Tags: Cards',
  },
  skills: {
    path: '',
    tags: ['modals'],
    internalOnly: false,
    stories: ['default'],
    description: 'Skill selector feature for freelancers',
  },
  'upgrade-item': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default', 'free-upgrade', 'promo-price', 'variation'],
    description:
      'The upgrade item pattern consists of pre-formatted price, promo price indicator (if available), branded tags and description.',
  },
  'upgrade-tag': {
    path: '',
    tags: ['tags'],
    internalOnly: true,
    stories: ['default', 'sizes', 'upgrade-types'],
    description: 'Tags for project/contest upgrades',
  },
  'user-feedback': {
    path: '',
    tags: ['modals'],
    internalOnly: false,
    stories: ['default'],
    description: 'Use this to ask for user feedback for a specific Campaign.',
  },
  'user-info': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default', 'user-avatar'],
    description: 'Layout for Users Info',
  },
  'user-rehire-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A card used in the dashboard rehire component that shows freelancer details as well as information from the most recent review left by the client to the freelancer.',
  },
  'user-search-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      'The user search card pattern display the user information in a single element.',
  },
  username: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'badge',
      'colors',
      'compact',
      'flag',
      'sizes',
      'truncate-text',
      'with-link',
    ],
    description: 'Component for showing username',
  },
  'video-record-input': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: true,
    stories: [
      'default',
      'custom-content-while-recording',
      'custom-copies',
      'custom-subcontent',
      'face-filter',
    ],
    description: 'A video button input to trigger the video recording modal.',
  },
  'video-record-modal': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default'],
    description: 'Video modal to record video files',
  },
  'worked-time': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'size'],
    description: 'A widget which display a user worked time',
  },
};
